// FIXME: Nul / 20 ça marche pas de lui set une transition parce qu'ils ont fait leur composant comme des cochons
export const ProgressFilledTrack = {
  baseStyle: {
    filledTrack: {
      transition: "width 660ms cubic-bezier(0.65, 0, 0.35, 1) !important",
    },
    track: {
      transition: "width 660ms cubic-bezier(0.65, 0, 0.35, 1) !important",
    },
  },
};
